<template>
  <div>
    <div class="modal fade order-placed" id="orderplaced" tabindex="-1" aria-labelledby="orderplacedLabel" aria-hidden="true" ref="PlaceOrderModal" style="z-index: 9999;">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-if="iswallet == '0' &&  !isChownmanPay">
          <div class="modal-body text-center">
            <img src="@/assets/images/confirmed-icn.svg" />
            <p class="mt-3 mb-1">
              {{ $t("Your order has been placed") }}. <br />
              {{$t("You can track order status on orders tab")}}.
            </p>
          </div>
          <div class="modal-footer full-btn d-block">
            <a href="javascript:void(0);" data-dismiss="modal">{{ $t("Track Order") }}</a>
          </div>
        </div>
        <div class="modal-content" v-if="iswallet == '1' &&  !isChownmanPay">
          <div class="modal-body text-center">
            <img src="@/assets/images/confirmed-icn.svg" />
            <p class="mt-3 mb-1"> {{ $t("Your recharge has been successfully") }}.</p>
          </div>
          <div class="modal-footer full-btn d-block">
            <a href="javascript:void(0);" data-dismiss="modal">{{$t("Ok")}}</a>
          </div>
        </div>
        <div class="modal-content" v-if="iswallet == '0' &&  isChownmanPay && !isGiftVoucher">
          <div class="modal-body text-center">
            <img src="@/assets/images/confirmed-icn.svg" />
            <p class="mt-3 mb-1">
              Hooray, You have completed your payment of <span v-html="$auth.setting.currency" class="currency"></span>{{chowmanPayTrans.final_amount}} and earned cashback of <span v-html="$auth.setting.currency" class="currency"></span>{{chowmanPayTrans.cashback}}
              <!-- Payment of <span v-html="$auth.setting.currency" class="currency"></span>{{chowmanPayTrans.final_amount}} is paid via Chowman Pay!. <br />
              {{$t("Your reference transaction id is")}}.<br />
              {{chowmanPayTrans.txid}} -->
            </p>  
          </div>
          <div class="modal-footer full-btn d-block">
            <a href="javascript:void(0);" data-dismiss="modal" class="trorder">{{ $t("OK") }}</a>
          </div>
        </div>
        <div class="modal-content" v-if="iswallet == '0' &&  isChownmanPay && isGiftVoucher">
          <div class="modal-body text-center">
            <img src="@/assets/images/confirmed-icn.svg" />
            <p class="mt-3 mb-1">
              Gift voucher send successfully!
            </p>  
          </div>
          <div class="modal-footer full-btn d-block">
            <a href="javascript:void(0);" data-dismiss="modal" class="trorder">{{ $t("OK") }}</a>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: ["orderId", "iswallet","isChownmanPay","chowmanPayTrans","isGiftVoucher"],
  mounted() {
    window.$(this.$refs.PlaceOrderModal).modal();
    $(this.$refs.PlaceOrderModal).on("hidden.bs.modal", this.oncloseModle);
  },
  methods: {
    ...mapMutations("product", ["clearCartItems"]),
    ...mapMutations("order", ["clearPlaceOrderData"]),

    oncloseModle() {
      if(!this.isChownmanPay){
        if (this.iswallet == "0") {
          this.$store.commit("product/clearCartItems");
          this.$store.commit("order/clearPlaceOrderData");
          localStorage.setItem("orderUploadImages", "");
          this.$router.push({name: "order-status",params: { order_id: this.base64_encode(this.orderId) },
          });
        } else {
          this.$router.push({ name: "wallet" });
        }
      }else{
        this.$router.push({name:'chowman-pay-history'});        
      }
    },
  },
};
</script>
<style>
.modal-footer .trorder .modal-footer .trorder:hover{
  background-color: var(--theme-button-text-second-color);
  color: white;
}
</style>
